@if(displayUsers && displayUsers.length > 0){
    @if(!group){
        <div class="flex align-items-center w-full justify-content-center avatar-group-container">
            @for (item of displayUsers; track (item?.idUser || $index); let i = $index) {
                @if(i + 1 <= maximumNumberUsersDisplay){
                    <div class="avatar-item-wrapper mr-1">
                        @if(item && item['status']){
                            <img [style.border]="'2.5px solid ' + getStatusColor(item['status'])"
                                 class="avatar-img"
                                 [src]="item['avatar'] ? item['avatar'] : 'assets/images/user.svg'"
                                 alt=""
                                 tooltipPosition="top"
                                 [pTooltip]="getUserTooltip(item)">
                            <span class="status-circle-dot"
                                  [style.backgroundColor]="getStatusColor(item['status'])"></span>
                        }@else if(item && item['symbol']){
                            <img [style.border-color]="item['symbol']"
                                 class="avatar-img"
                                 [src]="item['avatar'] ? item['avatar'] : 'assets/images/user.svg'"
                                 alt=""
                                 tooltipPosition="left"
                                 [pTooltip]="getUserTooltip(item)">
                        }@else{
                            <img class="avatar-img"
                                 [src]="item['avatar'] ? item['avatar'] : 'assets/images/user.svg'"
                                 alt=""
                                 tooltipPosition="left"
                                 [pTooltip]="getUserTooltip(item)">
                        }
                    </div>
                }
                @if (i === maximumNumberUsersDisplay){
                    <button pButton pRipple type="button" icon="pi pi-plus" style="background: black; width: 2rem; height: 2rem;" class="p-button-rounded p-button-secondary" (click)="op.toggle($event)"></button>
                }
            }
        </div>
    }@else {
        <div class="flex align-items-center w-full justify-content-center">
            <p-avatarGroup>
                @for (item of displayUsers; track (item?.idUser || $index); let i = $index) {
                    @if(i + 1 <= maximumNumberUsersDisplay){
                        <p-avatar [style]="{'width':'32px' , 'height':'32px' , 'cursor' : 'pointer' , 'display' : 'flex'}" [image]="item['avatar'] ? item['avatar'] : 'assets/images/user.svg'" shape="circle" tooltipPosition="left" [pTooltip]="getUserTooltip(item)"></p-avatar>
                    }
                    @if(i === maximumNumberUsersDisplay){
                        <p-avatar label="+" shape="circle" size="large" [style]="{'background-color':'#000000', 'color': '#ffffff', 'width':'32px' , 'height':'32px' , 'cursor' : 'pointer' , 'display' : 'flex'}" (click)="op.toggle($event)"></p-avatar>
                    }
                }
            </p-avatarGroup>
        </div>
    }
}@else {
    -
}


<p-overlayPanel #op [style]="{width: '280px'}" appendTo="body">
    <ng-template pTemplate>
       <div class="grid m-0">
            <p-scrollPanel [style]="{width: '100%', height: '180px'}">
                @for (item of overflowUsers; track (item?.idUser || $index)) {
                    <div class="col-12 flex align-items-center py-2 border-bottom-1 surface-border">
                        <div class="avatar-item-wrapper mr-2">
                            <img [style.border]="item['status'] ? ('2.5px solid ' + getStatusColor(item['status'])) : 'none'"
                                 class="avatar-img"
                                 [src]="item['avatar'] ? item['avatar'] : 'assets/images/user.svg'"
                                 alt=""
                                 tooltipPosition="left"
                                 [pTooltip]="getUserTooltip(item)">
                            @if(item['status']){
                                <span class="status-circle-dot" [style.backgroundColor]="getStatusColor(item['status'])"></span>
                            }
                        </div>
                        <div class="flex flex-column text-left" style="overflow: hidden; flex: 1;">
                            <span class="font-bold text-sm text-overflow-ellipsis white-space-nowrap overflow-hidden" [title]="(item['name'] || '') + ' ' + (item['lastName'] || '')">
                                {{item['name']}} {{item['lastName']}}
                            </span>
                            @if(item['positionName'] || item['position']){
                                <span class="text-xs text-500 text-overflow-ellipsis white-space-nowrap overflow-hidden" [title]="item['positionName'] || item['position']">
                                    {{item['positionName'] || item['position']}}
                                </span>
                            }
                            @if(item['status']){
                                <span class="text-xs font-semibold" [style.color]="getStatusColor(item['status'])">
                                    {{getStatusLabel(item['status'])}}
                                </span>
                            }
                        </div>
                    </div> 
                }
            </p-scrollPanel>
       </div>
    </ng-template>
</p-overlayPanel>